import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { KeyUri, config } from '../key';

const QuickRoutes = ({ onSelectRoute }) => {
  const [quickRoutes, setQuickRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const fetchQuickRoutes = async () => {
      try {
        const res = await axios.get(`${KeyUri.BACKEND_URI}/get-all-quick-routes`, config);
        const routes = (res.data || []).map(r => ({
          _id: r._id,
          name: r.name,
          from_location_id: r.from_location_id
            ? {
                _id: r.from_location_id._id,
                name: r.from_location_id.name,
                points: (r.from_location_id.points || []).map(p => ({
                  id: p._id,
                  location: p.location,
                })),
              }
            : null,
          to_location_id: r.to_location_id
            ? {
                _id: r.to_location_id._id,
                name: r.to_location_id.name,
                points: (r.to_location_id.points || []).map(p => ({
                  id: p._id,
                  location: p.location,
                })),
              }
            : null,
        }));
        setQuickRoutes(routes);
      } catch (error) {
        console.error('Error fetching quick routes:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchQuickRoutes();
  }, []);

  useEffect(() => {
    if (quickRoutes.length === 0) return;
    const container = scrollContainerRef.current;
    if (!container) return;

    let scrollSpeed = 1; // pixels per tick
    const scrollInterval = setInterval(() => {
      container.scrollLeft += scrollSpeed;
      // When scrolled through half (since we duplicate), reset to start
      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft -= container.scrollWidth / 2;
      }
    }, 20); // adjust 20ms for smoothness

    return () => clearInterval(scrollInterval);
  }, [quickRoutes]);

  if (isLoading) return <p>Loading quick routes...</p>;
  if (quickRoutes.length === 0) return <p>No quick routes available.</p>;

  // Duplicate routes for seamless scrolling
  const scrollingRoutes = [...quickRoutes, ...quickRoutes];

  return (
      <div className="w-full overflow-hidden relative -mb-6">
      {/* CSS injected directly in the component */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .scroll-wrapper {
          display: flex;
          width: max-content;
          animation: scroll 25s linear infinite;
        }
        .scroll-item {
          flex: 0 0 auto;
          margin-right: 1rem;
          padding: 3px 1rem;
          background: #22c55e;
          color: white;
          border-radius: 0.5rem;
          white-space: nowrap;
          cursor: pointer;
          transition: background 0.3s;
        }
        .scroll-item:hover {
          background: #16a34a;
        }
      `}</style>

      <div className="flex">
        <div className="scroll-wrapper">
          {scrollingRoutes.map((route, index) => (
            <div
              key={`${route._id}-${index}`}
              onClick={() => onSelectRoute(route)}
              className="scroll-item px-3 py-1 bg-green-500 text-white rounded-lg flex-shrink-0"
            >
              {route.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickRoutes;
